module.exports = ".age-box{\r\n    width:70px;\r\n}"